/**
 * created by lei lei on 2020/5/9
 */
import React, {Component} from 'react';
import MyDesk from "../view/desktop/MyDesk";
import ActivityPendingComponents from "../view/desktop/components/activityPending/ActivityPendingComponents";
import ActivityOtherPendingComponents from "../view/desktop/components/activityPending/ActivityOtherPendingComponents";
import ActivityTrendsComponents from "../view/desktop/components/activityTrends/ActivityTrendsComponents";
import TopicSubmissionReminderComponents from "../view/desktop/components/activityTrends/TopicSubmissionReminderComponents";
import FollowUpCorrespondenceComponents from "../view/desktop/components/activityTrends/FollowUpCorrespondenceComponents";
import ActivityCompletionComponents from "../view/desktop/components/activityCompletion/ActivityCompletionComponents";
import ActivityRankingComponents from "../view/desktop/components/activityRanking/ActivityRankingComponents";
import ResourceStaticComponents from "../view/desktop/components/resourceStatic/ResourceStaticComponents";
import PublishRankingsComponents from "../view/desktop/components/publishRank/PublishRankingsComponents";
import Head from'../view/desktop/components/head/Head'
import Shortcuts from'../view/desktop/components/shortcuts/Shortcuts'
import ActivityPendingAllComponents from "../view/desktop/components/activityPending/ActivityPendingAllComponents";
import CustomEditor from'../view/components/editor/CustomEditor'
import EditorComponents135 from'../view/components/editor135/EditorComponents135'
import IconStatisticComponents from '../view/components/iconStatistic/IconStatisticComponents'
import NumberArticlesComponents from '../view/components/numberArticles/NumberArticlesComponents'
import MediaInformationComponents from '../view/components/mediaInformation/MediaInformationComponents'
import CustomTableComponents from '../view/components/customTable/CustomTableComponents'
import TrendAnalysisComponents from '../view/components/trendAnalysis/TrendAnalysisComponents'
import MediaManagement from '../view/mediaManagement/MediaManagement'
import StorageList from "../containers/StorageList";
import UserManagement from '../view/userManagement/UserManagement'
import {NO_FRAME} from "../constants";
import FaceRecognition from "../view/faceRecognition/FaceRecognition";
import PmsStaticMyDesk from "../view/desktop/PmsStaticMyDesk";
import ManuscriptPool from "../view/manuscriptPool/ManuscriptPool";
import OriginalManuscript from "../view/originalManuscript/OriginalManuscript";
import {ComponentsRouter} from "./ComponentsRouter";
import WeChatPublish from "../view/mediaRelease/weChatPublish/WeChatPublish";
import ChangePasswordPolicy from "../view/changePasswordPolicy/ChangePasswordPolicy";
import SelectResourceData from "../view/selectResourceData/selectResourceData";
import BussinessStatistics from '../view/bussinessStatistics/bussinessStatistics';
import OperatingStatistics from '../view/operatingStatistics/operatingStatistics';
import AllResources from '../view/allResources/AllResources';
import DeliveryResources from '../view/deliveryResources/DeliveryResources';
import SysMediaManagement from "../view/sysMediaManagement/SysMediaManagement";
import NewsContribute from "../view/newsContribute/NewsContribute";
import MediaRoleList from "../view/mediaRole/mediaRoleList";
import InterviewTasks from '../view/Interview/view/InterviewTasks'; // 采访任务
//统计分析
import ManuscriptList from "../view/statisticAnalysis/manuscriptList/ManuscriptList";
import SubmitStatistical from "../view/statisticAnalysis/submitStatistical/SubmitStatistical";
import PublicityManuscript from "../view/statisticAnalysis/publicityManuscript/PublicityManuscript";
import CluesStatistical from "../view/statisticAnalysis/cluesStatistical/CluesStatistical";
import ChoiceStatistical from "../view/statisticAnalysis/choiceStatistical/ChoiceStatistical";
import TaskStatistical from "../view/statisticAnalysis/taskStatistical/TaskStatistical";
import ManuscriptsStatistics from "../view/statisticAnalysis/manuscriptsStatistics/ManuscriptsStatistics";
import MediaStatistics from "../view/statisticAnalysis/mediaStatistics/MediaStatistics";
import ResourceStatistics from "../view/statisticAnalysis/resourceStatistics/ResourceStatistics";
///------------------融媒--------------------
import Atlas from "../view/atlas/Atlas";
import Video from "../view/video/Video";
import Audio from "../view/audio/Audio";
import SpecialColumn from "../view/specialColumn/SpecialColumn";
import FansManage from "../view/fansManage/FansManage";
import NumberManage from "../view/numberManage/NumberManage";
import IndexLink from "../view/indexLink/IndexLink";
import MessagePush from "../view/messagePush/MessagePush";

import PublishContent from "../view/publishContent/publishContent";
import EditWeiBo from "../components/weibo/editWeiBo";
import AllWeiboList from "../components/weibo/allWeiboList";
import PmsWriting from '../view/pmsWriting/pmsWriting';


//线索管理
import ClueManage from "../view/clueManage/ClueManage";
//在线人数信息
import OnlineNumberInfo from "../view/onlineNumberInfo/OnlineNumberInfo";

import SysLog from "../view/sysLog/SysLog";
import VisitLog from "../view/visitLog/VisitLog";

//用户管理  sys
import UserManagementSys from "../view/userManagementSys/UserManagementSys";

// 环境检测
import EnvironmentalMonitoring from "../view/environmentalMonitoring/environmentalMonitoring";

import ManuscriptManagement from "../view/manuscriptManagement/ManuscriptManagement";   //稿件管理
import ClueManagement from "../view/clueManagement/ClueManagement";   //线索管理
import AppointmentManagement from "../view/appointmentManagement/AppointmentManagement";   //约稿管理
import PermissionList from "../view/sysManagement/organizationalStructure/permission/PermissionList";
import {router} from "../view/newMediaMatrix/route/router";
import {mediaAdministerRouter} from "../view/mediaManage/router/mediaAdminister";
import Editor from "../view/editor/Editor"
import {TabRouter} from '../view/businessCenter/route/router'

import EditorUseDemo from"../view/editor/EditorUseDemo"
import {sysRouter} from "../view/sysManagement/route/router"
import {ResourceRouter}from "../view/resource/route/route"
import EditorShunt from "../view/editor/EditorShunt";
import {materialCenterRouter} from '../view/materialCenter/routes/router';
import {newUserManageRouter} from "../view/newUserManagement/router/newUserManageRouter";
import StationGroupManagement from '../view/stationGroupManagement/StationGroupManagement'
import WebsiteExtensionField from '../view/wesiteExtensionField/WesiteExtensionField';
import Website from "../view/mediaRelease/Website";
import {mediaReleaseRouter} from '../view/mediaRelease/routes/router'
import {newDesktopRouter} from "../view/newDesktop/route/router"
import Demo from "../view/components/treeModuleBySelectPerson/Demo";
import ChangeDept from "../containers/login/changeDept/ChangeDept";
import WebsiteDeliverRelation from "../view/websiteDeliverRelation/WebsiteDeliverRelation";
import {contentSecurityCenterRouter} from "../view/contentSecurityCenter/route/router";
import Notice from "../view/planningOfTopics/notice/Notice";
import {selectedTopicRoute} from "../view/sysManagement/selectedTopicManagement/route/route";
import {approximationsManagementRouter} from "../view/approximationsManagement/router/approximationsManagement"
import {statisticalAnalysisRouter} from "../view/statisticalAnalysis/routes/router";
import {positionManageRoute} from "../view/positionManage/route/route";
import {contentManagement} from "../view/newMediaMatrix/pms/contenManagement/route/route";
import {positionSafetyManageRoute} from "../view/newMediaMatrix/pms/positionSafetyManage/route/route";
import {mediaList} from "../view/newMediaMatrix/pms/mediaMatrixNewList/route/route";
import {positionSystemSettingRoute} from "../view/newMediaMatrix/pms/positionSystemSetting/route/route";
import {positionOverviewRoute} from "../view/newMediaMatrix/pms/positionOverview/route/route";
export  const  ViewRouter =[
    ...ComponentsRouter,
    ...router,
    ...mediaAdministerRouter,
    ...newUserManageRouter,
    ...TabRouter,
    ...sysRouter,
    ...ResourceRouter,
    ...materialCenterRouter,//素材中心模块路由
    ...mediaReleaseRouter,//融媒发布模块
    ...newDesktopRouter,//工作桌面
    ...contentSecurityCenterRouter,//内容安全中心,
    ...selectedTopicRoute,//线索选题模块路由，
    ...approximationsManagementRouter,//约稿模块路由
    ...statisticalAnalysisRouter,//统计分析
    ...positionManageRoute,
    ...contentManagement,
    ...positionSafetyManageRoute,
    ...mediaList,
    ...positionSystemSettingRoute,
    ...positionOverviewRoute,
    {
        path: "/view/desktop/myDesktop",
        component: MyDesk
    },
    {
        path: "/view/desktop/staticMyDesk",
        component: PmsStaticMyDesk
    },
    {
        path: "/view/desktop/components/Head",
        component: Head
    },
    {
        path: "/view/desktop/components/ActivityPendingComponents",
        component: ActivityPendingComponents
    },
    {
        path: "/view/desktop/components/ActivityOtherPendingComponents",
        component: ActivityOtherPendingComponents
    },
    {
        path: "/view/desktop/components/ActivityTrendsComponents",
        component: ActivityTrendsComponents
    },
    {
        path: "/view/desktop/components/TopicSubmissionReminderComponents",
        component: TopicSubmissionReminderComponents
    },
    {
        path: "/view/desktop/components/FollowUpCorrespondenceComponents",
        component: FollowUpCorrespondenceComponents
    },
    {
        path: "/view/desktop/components/ActivityCompletionComponents",
        component: ActivityCompletionComponents
    },
    {
        path: "/view/desktop/components/ActivityRankingComponents",
        component: ActivityRankingComponents
    },
    {
        path: "/view/desktop/components/ResourceStaticComponents",
        component: ResourceStaticComponents
    },
    {
        path: "/view/desktop/components/PublishRankingsComponents",
        component: PublishRankingsComponents
    },
    {
        path: "/view/desktop/components/Shortcuts",
        component: Shortcuts
    },
    {
        path: "/view/desktop/components/ActivityPendingAllComponents",
        component: ActivityPendingAllComponents
    },
    {
        path: "/view/components/CustomEditor",
        component: CustomEditor, frame:NO_FRAME
    }, {
        path: "/view/components/EditorComponents135",
        component: EditorComponents135, frame:NO_FRAME
    },
    {
        path: "/view/components/IconStatisticComponents",//图标类粉丝数
        component: IconStatisticComponents
    },
    {
        path: "/view/components/NumberArticlesComponents",//横向管控粉丝数列表
        component: NumberArticlesComponents
    },{
        path: "/view/components/MediaInformationComponents",//媒体信息
        component: MediaInformationComponents
    },
    {
        path: "/view/components/CustomTableComponents",//自定义表格
        component: CustomTableComponents
    },
    {
        path: "/view/components/TrendAnalysisComponents",//横向管控趋势分析
        component: TrendAnalysisComponents
    },
    /*    {
            path: "/view/components/MyMediaInformation",
            component: <MyMediaInformation/>
        },*/
    {
        path: "/view/mediaManagement",//媒体管理
        component: MediaManagement
    },
    {
        //    /view/components/quanbuwenjian/StoragePicList/5ede033f02680900013d1fd6 ,访问插件路由
        //    view/components/quanbuwenjian/PluginStoragePicList/5ede033f02680900013d1fd6
        path: "/view/components/quanbuwenjian/:resourceComponent/:currentId",//资源库插件
        component: StorageList, frame:NO_FRAME
    },
    {
        path: "/view/userManagement",//用户管理
        component: UserManagement
    },
    {
        path: "/view/components/FaceRecognition",//人脸识别
        component: FaceRecognition
    },
    {
        path: "/view/manuscriptPool",//稿件池
        component: ManuscriptPool
    },
    {
        // path: "/view/website/originalManuscript/:mediaCode",//融媒发布网站原创稿件 菜单里面的id/或者媒体code  ;//view/website/originalManuscript/xww
        path:"/website/wangzhan/:mediaCode/activityStory",
        component: OriginalManuscript, componentProps:{mediaType:"1", title:"任务稿件"},//跳转链接循环后  '/view/website/originalManuscript/'+item.id
    },
    {
        path: "/view/wechat/originalManuscript/:mediaCode",//融媒发布微信原创稿件 菜单里面的id/或者媒体code  ;//view/wechat/originalManuscript/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"2", title:"任务稿件"}//跳转链接循环后  '/view/wechat/originalManuscript/'+item.id
    },
    {
        path: "/weibo/weiboIndex/activityStory/:mediaCode",//融媒发布微博原创稿件 菜单里面的id/或者媒体code  ;//view/wechat/originalManuscript/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"3", title:"任务稿件"}//跳转链接循环后  '/view/wechat/originalManuscript/'+item.id
    },
    {
        path: "/douyin/douyinIndex/activityStory/:mediaCode",//融媒发布抖音原创稿件 菜单里面的id/或者媒体code  ;//view/wechat/originalManuscript/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"5", title:"任务稿件"}//跳转链接循环后  '/view/wechat/originalManuscript/'+item.id
    },
    {
        path: "/view/otherMedia/originalManuscript/:mediaCode",// 其他媒体里面的原创稿件 
        component: OriginalManuscript, componentProps:{mediaType:"6", title:"任务稿件"}
    },
    {
        path: "/view/website/contribution/:mediaCode",//融媒发布网站投稿稿件 菜单里面的id/或者媒体code  ;//view/website/contribution/xww
        component: OriginalManuscript, componentProps:{mediaType:"1", title:"投稿稿件"}//跳转链接循环后  '/view/website/contribution/'+item.id
    },
    {
        path: "/view/wechat/contribution/:mediaCode",//融媒发布微信投稿稿件 菜单里面的id/或者媒体code  ;//view/wechat/contribution/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"2", title:"投稿稿件"}//跳转链接循环后  '/view/wechat/contribution/'+item.id
    },
    {
        path: "/weibo/weiboIndex/contribution/:mediaCode",//融媒发布微博投稿稿件 菜单里面的id/或者媒体code  ;//view/wechat/contribution/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"3", title:"投稿稿件"}//跳转链接循环后  '/view/wechat/contribution/'+item.id
    },
    {
        path: "/douyin/douyinIndex/contribution/:mediaCode",//融媒发布抖音投稿稿件 菜单里面的id/或者媒体code  ;//view/wechat/contribution/bdcsdyh
        component: OriginalManuscript, componentProps:{mediaType:"5", title:"投稿稿件"}//跳转链接循环后  '/view/wechat/contribution/'+item.id
    },
    {
        path: "/view/otherMedia/contribution/:mediaCode",// 其他媒体里面的原创稿件 
        component: OriginalManuscript, componentProps:{mediaType:"6", title:"投稿稿件"}
    },
    {
        path: "/view/otherMediaContributions/:mediaCode",//融媒其他媒体稿件 菜单里面的id/或者媒体code  ;//view/otherMediaContributions/xww
        component: OriginalManuscript, componentProps:{mediaType:"other", title:"其他媒体稿件"}//跳转链接循环后  '/view/website/otherMediaContributions/'+item.id
    },
    {
        path: "/view/weChatPublish/:currentMedia",//微信发布  ;//view/weChatPublish/bdnrdsj
        component: WeChatPublish,//跳转链接循环后  '//view/weChatPublish/bdnrdsj
    },
    // {
    //     path:"/weibo/weiboIndex/:currentMedia/allweibo",    // 全部微博
    //     component:AllWeiboList, componentProps:{type:"all"}
    // },
    // {
    //     path:"/weibo/weiboIndex/:currentMedia/mydraft",     // 草稿箱
    //     component:WeiboList, componentProps:{type:"mydraft"}
    // },
    // {
    //     path:"/weibo/weiboIndex/:currentMedia/audit",     // 审核中
    //     component:AllWeiboList, componentProps:{type:"audit"}
    // },
    // {
    //     path:"/weibo/weiboIndex/:currentMedia/myneedhand",     // 待我处理
    //     component:WeiboList, componentProps:{type:"myneedhand"}
    // },
    {
        path:"/weibo/weiboIndex/:currentMedia/timetask",     // 定时发布
        component:AllWeiboList, componentProps:{type:"timetask"}
    },
    {
        path:"/weibo/weiboIndex/:currentMedia/release",     // 已发布
        component:AllWeiboList, componentProps:{type:"release"}
    },
    {
        path:"/weibo/weiboIndex/:currentMedia/undo",     // 撤回
        component:AllWeiboList, componentProps:{type:"undo"}
    },
    {
        path:"/weibo/weiboAdd/:currentMedia/:weiboId",
        component:EditWeiBo, frame:NO_FRAME
    },
    // {
    //     path:"/douyin/:mediaId",
    //     framePath:"/cm-sites/pms/douyin/douyin.html"
    // },
    {
        path:"/douyin/:mediaId",
        framePath:"/cm-sites/pms/douyin/douyin.html?menuType=all"
    },
    {
        path: "/view/menuManagement",//菜单管理sys端
        component: PermissionList,//菜单管理sys端
    },
    {
        path: "/view/changePasswordPolicy",//sys端修改密码策略
        component: ChangePasswordPolicy
    },
    {
        path: "/view/selectResourceData", // sys端 选择来源 数据维护
        component: SelectResourceData
    },
    {
        path: "/view/bussiness/statistics", //pms 业务统计页面
        component: BussinessStatistics
    },
    {
        path: '/view/operating/statistics', //pms 运营统计页面
        component: OperatingStatistics
    },

    {
        path: '/view/sysMediaManagement', //sys端  媒体管理
        component: SysMediaManagement
    },
    {
        path: '/view/allResources/:resourceId', //pms端  全部资源
        component: AllResources, componentProps:{resourceType:0}
    },
    {
        path: '/view/allPictures/:resourceId', //pms端  全部图片
        component: AllResources, componentProps:{resourceType:1}
    },
    {
        path: '/view/allAudios/:resourceId', //pms端  全部音频
        component: AllResources, componentProps:{resourceType:2}
    },
    {
        path: '/view/allVideos/:resourceId', //pms端  全部视频
        component: AllResources, componentProps:{resourceType:3}
    },
    {
        path: '/view/allFiles/:resourceId', //pms端   其他文件
        component: AllResources, componentProps:{resourceType:4}
    },
    {
        path: "/view/media/atlas", //pms端 图集页面
        component: Atlas,
    },
    {
        path: "/view/media/video", //pms端 视频页面
        component: Video,
    },
    {
        path: "/view/media/audio", //pms端 音频页面
        component: Audio,
    },
    {
        path: "/view/media/specialColumn", //pms端 专栏页面
        component: SpecialColumn,
    },
    {
        path: "/view/media/fansManage", //pms端 粉丝管理页面
        component: FansManage,
    },
    {
        path: "/view/media/numberManage", //pms端 融媒号管理页面
        component: NumberManage,
    },
    {
        path: "/view/media/indexLink", //pms端 首页链接管理页面
        component: IndexLink,
    },
    {
        path: "/view/media/messagePush", //pms端 首页链接管理页面
        component: MessagePush,
    },
    {
        path: '/view/pmsWriting',  //pms端写稿页面
        component: PmsWriting
    },
    {
        path: "/view/deliveryResources", //pms端 投稿资源
        component: DeliveryResources,
    },
    {
        path: "/view/selectResourceData", // sys端 选择来源 数据维护
        component: SelectResourceData
    },
    {
        path: "/view/publish/content/:mediaCode", //已发布内容
        component: PublishContent
    },
    {
        path: "/view/selectTopic/clueManage", //线索管理
        component: ClueManage
    },
    {
        path: "/view/securityConfig/onlineNumberInfo", //在线人数信息
        component: OnlineNumberInfo
    },
    {
        path: "/view/sysLog", //sys 端  系统日志
        component: SysLog
    },
    {
        path: "/view/userOrganization/userManagementSys", //sys端  用户管理
        component: UserManagementSys
    },
    {
        path: "/view/visitLog", //sys 端  用户访问日志
        component: VisitLog
    },
    {
        path: "/view/environmentalMonitoring/environmentMonitor",  //环境检测
        component: EnvironmentalMonitoring,
    },
    {
        path: "/view/statisticAnalysis/manuscriptList", //pms端 统计分析(全部稿件列表)
        component: ManuscriptList
    },
    {
        path: "/view/statisticAnalysis/submitStatistical", //pms端 统计分析(投稿统计)
        component: SubmitStatistical
    },
    {
        path: "/view/statisticAnalysis/publicityManuscript", //pms端 统计分析(宣传部稿件)
        component: PublicityManuscript
    },
    {
        path: "/view/statisticAnalysis/cluesStatistical", //pms端 统计分析(线索统计)
        component: CluesStatistical
    },
    {
        path: "/view/statisticAnalysis/choiceStatistical", //pms端 统计分析(选题统计)
        component: ChoiceStatistical
    },
    {
        path: "/view/statisticAnalysis/taskStatistical", //pms端 统计分析(采访任务统计)
        component: TaskStatistical
    },
    {
        path: "/view/statisticAnalysis/manuscriptsStatistics", //pms端 统计分析(约稿统计)
        component: ManuscriptsStatistics
    },
    {
        path: "/view/statisticAnalysis/mediaStatistics", //pms端 统计分析(媒体发布统计)
        component: MediaStatistics
    },
    {
        path: "/view/statisticAnalysis/resourceStatistics", //pms端 统计分析(资源统计)
        component: ResourceStatistics
    },
    {
        path: "/view/manuscriptManagement/ManuscriptManagement", //contribute端 稿件管理
        component: ManuscriptManagement
    },
    {
        path: "/view/appointmentManagement/AppointmentManagement", //contribute端 约稿管理
        component: AppointmentManagement
    },
    {
        path: "/view/clueManagement/ClueManagement", //contribute端 线索管理
        component: ClueManagement
    },
    {
        path: "/view/editor/editor/:storyId", //新组建编辑器   /view/editor/editor/0
        component: Editor, frame:"no-frame"//NO_FRAME
    },
    {
        path: "/view/editor/editor/:configName/:id", //编辑器分流器   /view/editor/editor/story/0
        component: EditorShunt, frame:"no-frame"//NO_FRAME
    },
    {
        path: "/view/editor/editorUseDemo", //新组建编辑器   /view/editor/editor/0
        component: EditorUseDemo,
    },
    {
        path:"/view/stationGroupManagement/StationGroupManagement",//站群管理客户端管理
        component:StationGroupManagement
    },

    {
        path: "/view/newsContribute/NewsContribute", //pms端 二级单位视角(新闻投稿)
        component: NewsContribute,
    },

    {
        path: "/view/mediaRelease/website", //pms端 demo
        component: Website,
    },

    {
        path: "/view/treeModule/demo", //pms端 树结构demo
        component: Demo,
    },
    {
        path: "/view/systemSet/mediaRole", //媒体角色
        component: MediaRoleList,
    },
    {
        path:"/view/sysManagement/websiteExtensionField",//网站扩展字段
        component:WebsiteExtensionField
    },
    {
        path:"/view/sysManagement/changeDept",//登录切换部门
        component:ChangeDept
    },
    {
        path:"/view/sysManagement/websiteDeliverRelation",//网站投递关系
        component:WebsiteDeliverRelation
    },
    {
        path:"/view/sysManagement/notice",//通知公告
        component:Notice
    },
    {
        path: '/view/interview/:differentTake', //createTask 创建者  receiverTask 领取者
        component: InterviewTasks,
    },
];


